import { ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";

export type QuoteRequestWeightDto = ClientInferResponseBody<
  typeof contract.quoteRequests.getWeight
>;

export const fetchQuoteRequestWeight = async (
  id: string,
): Promise<QuoteRequestWeightDto | null> => {
  const response = await api.quoteRequests.getWeight.query({ params: { id } });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
